<template lang="pug">
    input#barcode-scanner-input(
        ref="scanner"
        @blur="scannerBlurHandler()"
        maxlength="1"
        @keydown="$emit('keydown', $event)"
        )
</template>

<script>
export default {
    name: 'barcode-scanner-handler',
    props: {
        minCodeLength: {
            type: Number,
            default: 10
        }
    },
    data: function(){
        return {
        }
    },
    computed: {},
    methods: {
        onBarcodeScanned: function(code){
            if(document.activeElement.tagName === 'INPUT' && document.activeElement.id !== 'barcode-scanner-input'){
                let charsToRemove = code.length
                let val = document.activeElement.value
                val = val.slice(0, (charsToRemove * -1))
                setTimeout(() => {
                    document.activeElement.value = val
                }, 150);
            }
            if(document.activeElement.id === 'barcode-scanner-input' && code && code.length >= this.minCodeLength){
                this.$emit('codescanned', code)
            }   
        },
        scannerBlurHandler(){            
            setTimeout(()=>{
                if(document.activeElement.tagName === 'INPUT') return
                this.focusScanner()
                this.$emit('scanner:blur')
            }, 10)
        },
        focusScanner(){
            document.getElementById('barcode-scanner-input').focus()
            document.getElementById('barcode-scanner-input').blur()
            document.getElementById('barcode-scanner-input').focus()
        },
    },
    watch: {},
    components: {},
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    mounted: function(){
        this.$barcodeScanner.init(this.onBarcodeScanned)
        let inputsArray = document.querySelectorAll('input')
        inputsArray.forEach(elem => {
            if(elem.id === 'barcode-scanner-input') return
            elem.addEventListener('blur', this.focusScanner)
        })
        this.focusScanner()
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    beforeDestroy: function(){
        let inputsArray = document.querySelectorAll('input')
        inputsArray.forEach(elem => {
            elem.removeEventListener('blur', this.focusScanner)
        })
        this.$barcodeScanner.destroy()
    },
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss" scoped>
    #barcode-scanner-input{
        opacity: 0;
        position:fixed;
        top:0;
        left: 0;
        margin-left: -1000px;
    }
</style>